import React, { useState, useEffect } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Modal, Button } from "antd";
import data from "./event.json";
import { useNavigate } from "react-router-dom";
import { useCan } from "../../../utils/permissions";

const locales = {
  "en-US": enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const Index = ({
  arg: { calenderMonth, setCalenderMonth, calenderData, setCalenderData },
}) => {
  // import hooks here
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelData, setModelData] = useState(null);
  const can = useCan();
  const canReadWorkOrder = can("workOrders", "read");
  const [convertedArray, setConvertedArray] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getSelectEvent = (event) => {
    setIsModalOpen(!isModalOpen);
    setModelData(event);
  };

  const handleNavigate = (newDate) => {
    setCalenderMonth(format(newDate, "MM-yyyy"));
  };

  useEffect(() => {
    const newConvertedArray = [];

    if (calenderData.length > 0) {
      for (const data of calenderData) {
    
        // Extract date and time from the API response
        const datePart = data.date.slice(0, 10);
        const timePart = data.time;

        // Combine date and time using a space
        const dateTimeString = `${datePart} ${timePart}`;

        // Convert to JavaScript Date object
        const newStart = new Date(dateTimeString);

        // Create the end date (assuming it's the same as the start for your case)
        const newEnd = newStart;

        const convertedObj = {
          start: data.date,
          end: data.date,
          title: data.tranId,
          status: data.appstatus,
          description: data.apptStatusReason,
          address: data.address,
          jobType: data.jobType,
          name: data.name,
          techName: data.techName,
          priority: data.priority,
        };

        newConvertedArray.push(convertedObj);
      }
    }

    setConvertedArray(newConvertedArray);
  }, [calenderData]);

  const redirectToWorkOrderPage = (title) => {
 
    navigate("/work-order", { state: { title } });
  };

  
  return (
    <div>
      <Calendar
        localizer={localizer}
        events={convertedArray}
        startAccessor={(event) => new Date(event.start)}
        endAccessor={(event) => new Date(event.end)}
        style={{ height: 550 }}
        onSelectEvent={(event, e) => {
      
          getSelectEvent(event);
        }}
        onNavigate={(newDate) => handleNavigate(newDate)}
      />

      {/* <Modal
        title={modelData !== null && modelData.title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div>
          <span style={{ fontWeight: "bolder" }}>Start Date : </span>
          {modelData !== null && modelData.start.toLocaleString()}
        </div>
        <div>
          <span style={{ fontWeight: "bolder" }}>End Date :</span>{" "}
          {modelData !== null && modelData.end.toLocaleString()}
        </div>
        <div>
          {" "}
          <span style={{ fontWeight: "bolder" }}>Description : </span>
          {modelData && modelData.description !== null
            ? modelData.description
            : "No data"}
        </div>
        <div>
          {" "}
          <span style={{ fontWeight: "bolder" }}>Name : </span>
          {modelData && modelData.name !== null ? modelData.name : "No data"}
        </div>
        <div>
          {" "}
          <span style={{ fontWeight: "bolder" }}>Type Of Order : </span>
          {modelData && modelData.jobType !== null
            ? modelData.jobType
            : "No data"}
        </div>
        <div>
          {" "}
          <span style={{ fontWeight: "bolder" }}>Tech Assigned : </span>
          {modelData && modelData.techName !== null
            ? modelData.techName
            : "No data"}
        </div>
        <div>
          {" "}
          <span style={{ fontWeight: "bolder" }}>Priority : </span>
          {modelData && modelData.priority !== null
            ? modelData.priority
            : "No data"}
        </div>
        <div>
          {" "}
          <span style={{ fontWeight: "bolder" }}>Address : </span>
          {modelData && modelData.address !== null
            ? modelData.address
            : "No data"}
        </div>
        <div>{modelData !== null ? modelData.data : "No data"}</div>

        <div style={{ marginTop: "10px" }}>
          <button type="primary">Job Order</button>
        </div>
      </Modal> */}

      <Modal
        title={modelData !== null && modelData.title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="tupdate mt-4">Details</div>
        <div>
          <div className="row mt-3">
            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                Start Date
              </div>
              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <input
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={modelData !== null && modelData.start.toLocaleString()}
                />
              </div>
            </div>

            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head ">
                End Date
              </div>

              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <input
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={modelData !== null && modelData.end.toLocaleString()}
                />
              </div>
            </div>

            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head ">
                Description
              </div>

              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <input
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={
                    modelData && modelData.description !== null
                      ? modelData.description
                      : "No data"
                  }
                />
              </div>
            </div>

            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head ">Name</div>

              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <input
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={
                    modelData && modelData.name !== null
                      ? modelData.name
                      : "No data"
                  }
                />
              </div>
            </div>

            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head ">
                Type Of Order
              </div>

              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <input
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={
                    modelData && modelData.jobType !== null
                      ? modelData.jobType
                      : "No data"
                  }
                />
              </div>
            </div>

            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head ">
                Tech Assigned
              </div>

              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <input
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={
                    modelData && modelData.techName !== null
                      ? modelData.techName
                      : "No data"
                  }
                />
              </div>
            </div>

            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head ">
                Priority
              </div>

              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <input
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={
                    modelData && modelData.priority !== null
                      ? modelData.priority
                      : "No data"
                  }
                />
              </div>
            </div>

            <div className="mb-3 d-flex gap-2">
              <div className="col-lg-2 col-md-4 col-sm-12 sub2head ">
                Address
              </div>

              <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
                <textarea
                  rows={6}
                  className="form-control"
                  name="device"
                  type="text"
                  disabled
                  value={
                    modelData && modelData.address !== null
                      ? modelData.address
                      : "No data"
                  }
                />
              </div>
            </div>

            <div>{modelData !== null ? modelData.data : "No data"}</div>
          </div>

          {/* -----button----- */}
          <div className="d-flex mt-4 mb-3 gap-2 justify-content-center">
            <Button
              onClick={() => redirectToWorkOrderPage(modelData.title)}
              type="primary"
              disabled={!canReadWorkOrder}
            >
              Go to Job Order
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Index;
